import React from 'react';
import { MenuItem, Typography, Tooltip } from '@mui/material';
import { PopperMenuList } from './ui/popper-menulist';

export const MenuDropdown = ({ anchorEl, onClose, navPages }) => {
    return (
        <PopperMenuList anchorEl={anchorEl} onClose={onClose}>
            {navPages?.map(navItem => {
                const content = (
                    <MenuItem
                        key={navItem.label}
                        component='a'
                        href={navItem.id !== 'logout' ? navItem.href : null}
                        onClick={async e => {
                            if (navItem.onClick) await navItem.onClick(e);
                            onClose(e);
                        }}
                        sx={{
                            padding: '0 16px',
                            alignItems: 'center',
                            height: 36
                        }}
                        disabled={navItem.disabled}
                    >
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: '24px',
                                letterSpacing: '-0.176px',
                                color: '#333333'
                            }}
                        >
                            {navItem.label}
                        </Typography>
                    </MenuItem>
                );

                if (navItem.disabled) {
                    return (
                        <Tooltip
                            key={navItem.label}
                            title='This feature is unavailable. Please ensure your Tasker subscription is active to create a listing'
                        >
                            <span style={{ display: 'block' }}>{content}</span>
                        </Tooltip>
                    );
                }

                return content;
            })}
        </PopperMenuList>
    );
};
